(function () {
  if (window.__fabHeroTagScrollBound) return;
  window.__fabHeroTagScrollBound = true;

  var SCROLL_THRESHOLD = 24;

  function updateHeroTags() {
    var hidden = window.scrollY > SCROLL_THRESHOLD;
    document.querySelectorAll('.fab-hero-tag').forEach(function (tag) {
      tag.classList.toggle('fab-hero-tag--scroll-hidden', hidden);
    });
  }

  window.addEventListener('scroll', updateHeroTags, { passive: true });
  window.addEventListener('resize', updateHeroTags, { passive: true });
  updateHeroTags();
})();
